import { Alert, Col, Row } from "antd";
import "./Tab_UserRequests.scss";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../context/userContext";
import { getOffersByUser } from "../../../services/user/user";
import { getProductsDetails } from "../../../services/productsDetails/productsDetails";
import { formatNumber } from "../../../helper/fomartNum";
import { Link } from "react-router-dom";

function Tab_UserRequests() {
  const { currentUser } = useContext(UserContext);
  const [offers, setOffers] = useState([]);
  const [productsDetails, setProductsDetails] = useState([]);

  useEffect(() => {
    const load = async () => {
      if (!currentUser) return;

      const result = await getOffersByUser(currentUser.username);
      setOffers(result);

      const productsDetailsArr = await Promise.all(
        result.map((offer) => getProductsDetails(offer.productId))
      );

      const flatProducts = productsDetailsArr.map((p) => p[0]);
      setProductsDetails(flatProducts);
    };

    load();
  }, [currentUser]);

  return (
    <div className="user-requests">
      <Row gutter={[20, 20]}>
        {offers
          .slice()
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // mới nhất trước
          .map((offer) => {
            const product = productsDetails.find(
              (p) => p.id === offer.productId
            );
            if (!product) return null;

            return (
              <Col xxl={4} xl={4} key={offer.id}>
                <div className="req-item">
                  <Link to={`/products/${product.id}`}>
                    <div className="product-img">
                      <img src={product.thumbnail1} alt={product.name} />
                    </div>
                  </Link>

                  <div className="product-info">
                    <div className="product-name">{product.name}</div>
                    <div className="product-size">Size: {product.size}</div>
                    <div className="product-color">Màu: {product.color}</div>
                    <div className="offer-price">
                      Giá đề nghị: {formatNumber(offer.offerPrice)}đ
                    </div>
                    <div className="offer-status">
                      {offer.status === "pending" && (
                        <Alert message="Đang chờ" type="warning" showIcon />
                      )}

                      {offer.status === "accepted" && (
                        <Alert message="Đã chấp nhận" type="success" showIcon />
                      )}
                      {offer.status === "rejected" && (
                        <Alert message="Đã từ chối" type="error" showIcon />
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            );
          })}
      </Row>
    </div>
  );
}

export default Tab_UserRequests;
